import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <section data-testid="page-not-found" className="min-h-screen flex items-center bg-teh-bg pt-32 pb-20">
      <div className="teh-container text-center">
        <p className="teh-overline">404</p>
        <h1 className="font-serif text-6xl md:text-8xl mt-4 text-teh-deep leading-tight">
          Page <span className="italic text-teh-green">not found.</span>
        </h1>
        <p className="mt-6 text-teh-muted max-w-md mx-auto">
          The page you're looking for has moved or doesn't exist.
        </p>
        <Link
          to="/"
          className="mt-10 inline-flex items-center gap-2 px-7 py-4 bg-teh-navy text-white text-sm font-medium rounded-full hover:bg-teh-navyDark hover:gap-3 transition"
        >
          Back to home
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
